import * as types from '../actions/types';

const initialState = {
    page:1,
}

export default function tutorialPageReducer(state = initialState, action = null) {
    switch (action.type) {
        case types.TUTORIAL_LIST_PAGE_VALUE:
            return {page:action.payload} 
        default: return state
    }
}
